import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';

class WizardItemCalendar extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
          selectedDays: []
        };
        
        this.handleDayClick     = this.handleDayClick.bind(this);
        this.disabledDays       = this.disabledDays.bind(this);
        this.formatDaysToServer = this.formatDaysToServer.bind(this);
    }

    handleDayClick(day, modifiers = {}) {
        let selected = modifiers.selected
        const { selectedDays } = this.state;
        
        if( modifiers.disabled ) {
	        return;
        }  
        
        if (selected) {
            const selectedIndex = selectedDays.findIndex(selectedDay => DateUtils.isSameDay(selectedDay, day) );
            selectedDays.splice(selectedIndex, 1);
        } 
        else {
            if( this.state.selectedDays.length < this.props.data.MaxNumberOfDatesToSelect  ){
                selectedDays.push(day);
            }
        }
        
        this.setState({ selectedDays });

        if ( (selectedDays.length >= this.props.data.MinNumberOfDatesToSelect ) && (selectedDays.length <= this.props.data.MaxNumberOfDatesToSelect ) ){
            this.props.submitAnswer( this.formatDaysToServer(selectedDays) );
        }
        else{
            this.props.submitAnswer("");
        }

    }

    formatDaysToServer(arr){
        let newArr = [];
        for(let i = 0; i< arr.length; i++){
            let month = (arr[i].getMonth()+1) <= 9 ? "0" + String(arr[i].getMonth()+1) : String(arr[i].getMonth()+1)  ;
            let day = (arr[i].getDate() ) <= 9 ? "0" + String(arr[i].getDate()) : String(arr[i].getDate()) ;
            newArr.push( String( `${arr[i].getFullYear()}-${month}-${day}`) )
        }
        return newArr;
    }

    disabledDays(){
        let disabledDays = [];

        //Should weekends be allowed?
        if( !this.props.data.IsWeekendSelectAllowed ) {
	        disabledDays.push({ daysOfWeek: [0, 6] });
        }

        //Choose when we should start 
        let startDate = new Date(this.props.data.FirstPossibleDate );
	    disabledDays.push({
		    before: startDate
	    });
        return disabledDays;
    }

    render() {

        return (
            <div className="wizard-item wizard-item__calendar">
                <div>
                    <DayPicker
                        /* initialMonth={new Date(2017, 0)} */
                        firstDayOfWeek={this.props.data.FirstDayOfWeek}
                        selectedDays={this.state.selectedDays}
                        onDayClick={this.handleDayClick}
                        disabledDays={ this.disabledDays()}
                        months={this.props.data.MonthNames}
                        weekdaysShort={this.props.data.DayNames}

                    />
                </div>
            </div>
        )
    }
}

export default WizardItemCalendar;